/**
 * This file is part of Zoosh.
 *
 * Copyright (c) 2012-2020, Shoop Commerce Ltd. All rights reserved.
 *
 * This source code is licensed under the OSL-3.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import RegionsMap from "./data";

function handleRegionFields(countryRegions, regionCodeFieldSelector, regionFieldSelector) {
    var regionField = regionFieldSelector ? document.querySelector(regionFieldSelector) : null;
    var regionCodeField = document.querySelector(regionCodeFieldSelector);
    if (!regionCodeField) return;

    var regionCodeGroup = regionCodeField.closest(".form-group");
    var regionGroup = regionField ? regionField.closest(".form-group") : null;

    if (countryRegions) {
        if (regionGroup) regionGroup.style.display = "none";
        if (regionCodeGroup) regionCodeGroup.style.display = "";

        var currentValue = regionCodeField.value;

        // If it's not already a <select>, replace it with one
        if (regionCodeField.tagName !== "SELECT") {
            var newSelect = document.createElement("select");
            newSelect.id = regionCodeField.id;
            newSelect.name = regionCodeField.name;
            newSelect.className = "form-control";
            regionCodeField.replaceWith(newSelect);
            regionCodeField = newSelect;
        } else {
            regionCodeField.innerHTML = "";
        }

        // Add empty option
        var emptyOption = document.createElement("option");
        emptyOption.value = "";
        emptyOption.textContent = "---------";
        regionCodeField.appendChild(emptyOption);

        // Add region options
        countryRegions.forEach(function (region) {
            var option = document.createElement("option");
            option.value = region.code;
            option.textContent = region.name;
            if (currentValue === region.code) option.selected = true;
            regionCodeField.appendChild(option);
        });

        if (regionField) regionField.value = "";

        // Dispatch event so other code knows the field was initialized
        document.dispatchEvent(
            new CustomEvent("regionFieldInitialized", { detail: { field: regionCodeField } })
        );
    } else {
        if (regionGroup) regionGroup.style.display = "";
        if (regionCodeField) regionCodeField.value = "";
        if (regionCodeGroup) regionCodeGroup.style.display = "none";
    }
}

function updateRegion(countryFieldSelector, regionCodeFieldSelector, regionFieldSelector) {
    var countryField = document.querySelector(countryFieldSelector);
    if (!countryField) return;
    var country = countryField.value;
    var countryRegions = RegionsMap[country];
    handleRegionFields(countryRegions, regionCodeFieldSelector, regionFieldSelector);
}

// Public API — called from inline scripts generated by zoosh/regions/resources.py
window.initializeRegionFields = function (countryFieldSelector, regionCodeFieldSelector, regionFieldSelector) {
    regionFieldSelector = regionFieldSelector || null;
    updateRegion(countryFieldSelector, regionCodeFieldSelector, regionFieldSelector);

    var countryField = document.querySelector(countryFieldSelector);
    if (countryField) {
        countryField.addEventListener("change", function () {
            updateRegion(countryFieldSelector, regionCodeFieldSelector, regionFieldSelector);
        });
    }
};
window.REGIONS = RegionsMap;
